import * as React from "react";

const IconPromoSecure: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => {
  return (
    <svg width="57" height="56" viewBox="0 0 57 56" fill="none" {...props}>
      <path
        d="M28.5 52C28.5 52 48.5 42.4 48.5 28V11.2L28.5 4L8.5 11.2V28C8.5 42.4 28.5 52 28.5 52Z"
        stroke="#DFC947"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="28.5" cy="24" r="8" fill="#57AA55" />
    </svg>
  );
};

export { IconPromoSecure };
